import template from "./template.html";
import config from "../config";

export default function (editor) {
  const { DomComponents, BlockManager } = editor;

  DomComponents.addType("landing-page-header", {
    isComponent: (el: HTMLElement) => el.classList && el.classList.contains("landing-page-header"),
    model: {
      defaults: {
        draggable: true,
        removable: true,
        selectable: true,
        hoverable: true,
      },
    },
    view: {
      onRender({ model }) {
        model.findType("image").forEach(i => {
          let src = i.get("src");
          if(src.startsWith("data:")) src = "/public-files/logo";
          i.set({
            src,
            alt: "logo",
            locked: true,
            editable: false,
            selectable: false,
            hoverable: false,
          })
        });
      },
    },
  });

  BlockManager.add("landing-page-header", {
    ...config,
    label: "Header",
    content: template,
  });
}
